import React from 'react';
import { textEllipsis } from '../../../../shared/utils/smartutils';
import RenderTooltipCellByTypeView from '../../../../shared/components/RenderTooltipCell';
import {
  COMMUNICATION_TYPE,
  AUTHORIZATION_ANSWER,
} from '../../../../shared/utils/constants';

export default function (t, communicationType) {
  const getAnswerField = (answer) => {
    switch (answer) {
      case AUTHORIZATION_ANSWER.AUTHORIZED:
        return t('general.authorized');
      case AUTHORIZATION_ANSWER.UNAUTHORIZED:
        return t('general.unauthorized');
      default:
        return '';
    }
  };
  const columns = [
    {
      title: t('general.student'),
      field: 'studentName',
      cellStyle: textEllipsis,
      render: (rowData, typeView) => (
        <RenderTooltipCellByTypeView
          field={rowData.studentName}
          typeView={typeView}
          rowData={rowData}
        />
      ),
    },
    {
      title: t('general.classes-names'),
      field: 'classesNames',
      cellStyle: textEllipsis,
      render: (rowData, typeView) => (
        <RenderTooltipCellByTypeView
          field={rowData.classesNames}
          typeView={typeView}
          rowData={rowData}
        />
      ),
    },
    {
      title: t('general.responsible'),
      field: 'responsibleName',
      cellStyle: textEllipsis,
      render: (rowData, typeView) => (
        <RenderTooltipCellByTypeView
          field={rowData.responsibleName}
          typeView={typeView}
          rowData={rowData}
        />
      ),
    },
    {
      title: t('general.email'),
      field: 'responsibleEmail',
      cellStyle: textEllipsis,
      render: (rowData, typeView) => (
        <RenderTooltipCellByTypeView
          field={rowData.responsibleEmail}
          typeView={typeView}
          rowData={rowData}
        />
      ),
    },
    {
      title: t('general.phones'),
      field: 'responsiblePhone',
      cellStyle: textEllipsis,
      render: (rowData, typeView) => (
        <RenderTooltipCellByTypeView
          field={rowData.responsiblePhone}
          typeView={typeView}
          rowData={rowData}
        />
      ),
    },
    { title: t('general.visualized'), field: 'viewed' },
    {
      title: t('general.visualized-at'),
      field: 'previewDate',
      cellStyle: textEllipsis,
      render: (rowData, typeView) => (
        <RenderTooltipCellByTypeView
          field={rowData.previewDate}
          typeView={typeView}
          rowData={rowData}
        />
      ),
    },
    { title: t('general.visualized-by'), field: 'viewedBy' },
  ];

  if (communicationType === COMMUNICATION_TYPE.AUTHORIZATION) {
    columns.push({
      title: t('general.answer'),
      field: 'answer',
      cellStyle: textEllipsis,
      render: (rowData, typeView) => (
        <RenderTooltipCellByTypeView
          field={getAnswerField(rowData.answer)}
          typeView={typeView}
          rowData={rowData}
        />
      ),
    });
  }
  return columns;
}
